// ─── Icons ────────────────────────────────────────────────────────────────────

const IconMasonry = () => (
    <svg className="w-4 h-4" viewBox="0 0 16 16" fill="currentColor">
        <rect x="0" y="0" width="4" height="6" rx="1"/>
        <rect x="6" y="0" width="4" height="4" rx="1"/>
        <rect x="12" y="0" width="4" height="7" rx="1"/>
        <rect x="0" y="7" width="4" height="5" rx="1"/>
        <rect x="6" y="5" width="4" height="7" rx="1"/>
        <rect x="12" y="8" width="4" height="4" rx="1"/>
    </svg>
);

const IconColumns = () => (
    <svg className="w-4 h-4" viewBox="0 0 16 16" fill="currentColor">
        <rect x="0"  y="0" width="4" height="16" rx="1"/>
        <rect x="6"  y="0" width="4" height="16" rx="1"/>
        <rect x="12" y="0" width="4" height="16" rx="1"/>
    </svg>
);

// ─── View mode registry ───────────────────────────────────────────────────────
// Add a new entry here to register a new gallery view mode.

export const VIEW_MODES = [
    { id: 'masonry', Icon: IconMasonry, label: 'Masonry'           },
    { id: 'columns', Icon: IconColumns, label: 'Scrolling Columns' },
];

// ─── Switcher ─────────────────────────────────────────────────────────────────

/**
 * GalleryViewSwitcher
 * Pill toggle that lets the user pick a gallery view mode.
 *
 * Props:
 *   active    — currently active view id string
 *   onChange  — called with new view id when a button is clicked
 */
const GalleryViewSwitcher = ({ active, onChange }) => (
    <div className="flex items-center gap-1 bg-gray-100 rounded-xl p-1">
        {VIEW_MODES.map(({ id, Icon, label }) => (
            <button
                key={id}
                onClick={() => onChange(id)}
                title={label}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-black uppercase tracking-widest transition-all duration-200 ${
                    active === id
                        ? 'bg-white text-primary-950 shadow-sm'
                        : 'text-gray-400 hover:text-primary-950'
                }`}
            >
                <Icon />
                <span className="hidden sm:inline">{label}</span>
            </button>
        ))}
    </div>
);

export default GalleryViewSwitcher;
